import { getConfig } from '../config';
import { createContext, useContext, useEffect, useState } from "react";
import {
    loginUser,
    registerUser,
    forgotPassword
} from "../api/api.js";

const AuthContext = createContext();
const getApiUrl = () => getConfig().API_URL;

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loadingUser, setLoadingUser] = useState(true);

    // Load user data from local storage on mount
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }

        setLoadingUser(false);
    }, []);

    const login = async (email, password) => {
        try {
            const data = await loginUser(email, password);

            const userData = {
                userId: data.user_id,
                username: data.username,
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
            };

            localStorage.setItem(
                "user",
                JSON.stringify(userData)
            );

            setUser(userData);
            window.location.reload();

            return { 
                success: true 
            };

        } catch (error) {
            return {
                success: false,
                message: error.message
            };
        }
    };

    const register = async (
        email,
        password,
        username,
        country
    ) => {
        try {
            await registerUser(
                email,
                password,
                username,
                country
            );

            return await login(email, password);

        } catch (error) {
            return {
                success: false,
                message: error.message
            };
        }
    };

    // Logout function
    const logout = (withReload = true) => {
        localStorage.clear();
        setUser(null);

        if (withReload) {
            window.location.reload();
        }
    };

    const forgot_password = async (email) => {
        try {
            await forgotPassword(email);

            return {
                success: true,
                message: "Sent to email"
            };

        } catch (error) {

            return {
                success: false,
                message: error.message
            };
        }
    };

    return (
        <AuthContext.Provider value={{ user, loadingUser, login, register, logout, forgot_password }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook for consuming the AuthContext
export const useAuth = () => {
    return useContext(AuthContext);
};
